<nav aria-label="Page navigation" class="list-pagination">
  <div class="d-flex align-items-center justify-content-center gap-3 flex-wrap">
    <div class="d-flex align-items-center gap-2">
      <span class="size-label">Por página:</span>
      <div class="size-dropdown-wrapper">
        <button class="page-link size-btn" type="button" (click)="toggleSizeDropdown()">
          {{ pageSize }} <span class="arrow">▾</span>
        </button>
        @if(sizeDropdownOpen) {
          <ul class="size-dropdown">
            @for(opt of pageSizeOptions; track opt) {
              <li class="size-option" [class.size-option--active]="opt === pageSize" (click)="selectSize(opt)">
                @if(opt === pageSize) { <span class="size-check">✓</span> }
                {{ opt }}
              </li>
            }
          </ul>
        }
      </div>
    </div>
    <ul class="pagination mb-0">
      <li class="page-item">
        <a class="page-link" href="javascript:void(0)" (click)="goPrev()" aria-label="Anterior">‹</a>
      </li>
      @for(p of pages(); track p) {
        <li class="page-item">
          <a class="page-link" href="javascript:void(0)" (click)="pageChang(p)" [ngClass]="{'active':(p === page)}">{{p}}</a>
        </li>
      }
      <li class="page-item">
        <a class="page-link" href="javascript:void(0)" (click)="goNext()" aria-label="Siguiente">›</a>
      </li>
    </ul>
  </div>
</nav>